import { render, staticRenderFns } from "./SIS_ProgrammeOverview.vue?vue&type=template&id=6f5b06d9&"
import script from "./SIS_ProgrammeOverview.vue?vue&type=script&lang=ts&"
export * from "./SIS_ProgrammeOverview.vue?vue&type=script&lang=ts&"
import style0 from "./SIS_ProgrammeOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports